import request from '@/utils/request'

let StaffApi = {

  /*政商企会员列表*/
  list(data) {
    return request._post('/shop/plus.staff.Index/index', data);
},
/*添加政商企会员*/
add(data) {
    return request._post('/shop/plus.staff.Index/add', data);
},
/*修改政商企会员*/
edit(data) {
    return request._post('/shop/plus.staff.Index/edit', data);
},
/*删除政商企会员*/
del(data) {
    return request._post('/shop/plus.staff.Index/del', data);
},
/*政商企会员详情*/
detail(data) {
  return request._post('/shop/plus.staff.Index/detail', data);
},
saveSetting(data, errorback) {
  return request._post('/shop/plus.staff.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.staff.Setting/getSetting', data, errorback);
},

supply(data) {
  return request._post('/shop/plus.staff.Index/supply', data);
},
/*关联政商企会员到政商企*/
sadd(data) {
  return request._post('/shop/plus.staff.Index/sadd', data);
},
/*修改关联政商企会员到政商企*/
sedit(data) {
  return request._post('/shop/plus.staff.Index/sedit', data);
},
/*删除关联政商企会员到政商企*/
sdel(data) {
  return request._post('/shop/plus.staff.Index/sdel', data);
},
/*关联政商企会员到政商企详情*/
sdetail(data) {
  return request._post('/shop/plus.staff.Index/sdetail', data);
},

}
export default StaffApi;



// WEBPACK FOOTER //
// ./src/api/staff.js